
import {Component, ComponentOptions} from "@mecatran-components/component";
import {DomUtils, SystemUtils} from "@mecatran/utilities/src/index.web.mjs";
import {ListItem} from "@mecatran-components/listitem";
import {ListNavigationFeature} from "@mecatran-components/listnavigation";



export class DataSourceList extends SystemUtils.mix(Component).include(ListNavigationFeature){
    /**
     * 
     * @param dataSource instance of the datasource package 
     */
    constructor(dataSourceListOptions){
        var dataSourceListComponentOptions = (dataSourceListOptions && dataSourceListOptions.getDataSourceListComponentOptions) ? dataSourceListOptions.getDataSourceListComponentOptions() : undefined;
        super(dataSourceListComponentOptions);
        var _itemSelector;
        var _dataSource;

        Object.defineProperty(this,'dataSource',{
            set : function(dataSource){ 
                _dataSource  = dataSource;
            },
            get : function(){ return _dataSource },
            enumerable : true 
        });

        Object.defineProperty(this,'itemSelector',{
            set : function(i){ _itemSelector = i },
            get : function(){ return _itemSelector }
        });

        this.initDataSourceList(dataSourceListOptions)

    }

    // =======
    // private
    // -------

    setDataSource(d){ this.dataSource = d; }

    getDataSource(){ return this.dataSource; }  

    getItemSelector(){ return this.itemSelector }

    setItemSelector(i){ this.itemSelector = i }

    getItemComponentFactory(itemComponentOptions,createContext){   // RENAME 
        return (data)=>{
            var context = createContext(data);
            if (itemComponentOptions) itemComponentOptions.setContext(context);
            var itemComponent = new ListItem(itemComponentOptions);
            itemComponent.setData(data);
            itemComponent.build(); /* uncommented 21/05 */
            return itemComponent; 
        }
    }

    setCreateItemComponent(fn){
        this.createItemComponent = fn;
    }



    createItemComponents(dataArray){
        return dataArray.map(this.createItemComponent.bind(this));
    }

    storeItemComponents(components){
        var itemSelector = this.getItemSelector() || undefined;
        //this.getStorageManager().addComponents(components,'items', itemSelector);
        this.addSubComponents(components,'items',itemSelector)
        return;
    }

    processAll(fn){
        return (dataArray)=>dataArray.map(fn);
        
    }    
    
    
    onItemClick(event){
        console.log('onitemclick',event.target)
        var selectableElement = DomUtils.getClosest('.selectable',event.target)
        if (selectableElement){
            var data = selectableElement.getComponent().getData();
            this.emitSelectEvent(data, this.getDataSource().getName() )
        }
    }



    emitSelectEvent(data, datasetName){
        var event = new CustomEvent('selectEvent', { 'detail': {data, datasetName }, bubbles: true });  // https://developer.mozilla.org/fr/docs/Web/API/Event/Event
        this.getDomManager().getDomNode().dispatchEvent(event);
    }



    // TMP for TEST only 
    onSelectEvent(event){
        //console.log('select event',event.detail);
    }

    defaultCreateContext(data){ return data; }

    initItemComponentFactory(itemComponentOptions, createContext){
        var createContext = createContext || this.defaultCreateContext;
        var createItemComponent = this.getItemComponentFactory(itemComponentOptions, createContext);
        this.setCreateItemComponent(createItemComponent);
    }


    initDataSourceList(dataSourceListOptions){
        if (dataSourceListOptions){
            var dataSource = dataSourceListOptions.getDataSource();
            if (dataSource) this.setDataSource(dataSource);
            if (dataSourceListOptions.getItemComponentOptions()){
                this.initItemComponentFactory(dataSourceListOptions.getItemComponentOptions(),dataSourceListOptions.getCreateContext())
            }
            this.setItemSelector(dataSourceListOptions.getItemSelector())
            this.setHasNavigation(dataSourceListOptions.hasNavigation());
        }
    }

    //=========
    // overload
    // -------- 

    createContainerNode(){
        var div = document.createElement('div');
        return div;
    }

    createContentNode(){
        return;
    }

    createItemComponent(data){}

    build(...param){
        console.log('build datasourcelist')
        var dataSource = this.getDataSource();
        return dataSource.get(...param) // returns an array of objects 
                .then((dataArray)=>{
                    console.log('log',dataArray.length)
                    return dataArray;
                })
                .then(this.processAll(this.createItemComponent.bind(this)))
                .then(this.storeItemComponents.bind(this))   
                .then(super.build.bind(this))
                .then(()=>{
                    var parentNode = this.getDomManager().getDomNode();
                    if (this.getHasNavigation()) this.initListNavigation(parentNode); 
                    return;
                });
                
    }

    defineEventListeners(eventManager){
        eventManager.on('click', Component.dummyTrue, this.onItemClick.bind(this));
        eventManager.on('selectEvent', Component.dummyTrue, this.onSelectEvent.bind(this)); // TMP for TEST only 
    };

    

}

/**
 * dataSourceListOptions interface
 * --------------------------------
 * componentOptions - componentOptions optional
 * dataSource - DataSource object 
 * itemComponentOptions - ComponentOptions optional 
 * createContext - function  optional 
 * itemSelector - string optional
 * hasNavigation - boolean optional
 */



export class DataSourceListOptions{
    /**
     * 
     * @param dataSource - DataSource [mandatory]
     * @param dataSourceListComponentOptions instance of ComponentOptions
     * @param itemComponentOptions instance of ComponentOptions
     * @param createContext function 
     * @param itemSelector string 
     * @param hasNavigation boolean 
     */
    constructor(dataSource, dataSourceListComponentOptions, itemComponentOptions, createContext, itemSelector, hasNavigation ){
        var _dataSource = dataSource;
        var _dataSourceListComponentOptions = dataSourceListComponentOptions;
        var _itemComponentOptions = itemComponentOptions;
        var _createContext = createContext;
        var _itemSelector = itemSelector;
        var _hasNavigation = hasNavigation || false; 

        Object.defineProperty(this,'dataSource',{
            get : function(){ return _dataSource }
        });

        Object.defineProperty(this,'dataSourceListComponentOptions',{
            get : function(){ return _dataSourceListComponentOptions }
        });

        Object.defineProperty(this,'itemComponentOptions',{
            get : function(){ return _itemComponentOptions }
        });

        Object.defineProperty(this,'createContext',{
            get : function(){ return _createContext }
        });

        Object.defineProperty(this,'itemSelector',{
            get : function(){ return _itemSelector }
        });

        Object.defineProperty(this,'hasNavigation',{
            value : function(){ return _hasNavigation }
        })
    }

    // ===========
    // public 
    // -----------
    getDataSource(){ return this.dataSource }
    getDataSourceListComponentOptions(){ return this.dataSourceListComponentOptions }
    getItemComponentOptions(){ return this.itemComponentOptions }
    getCreateContext(){ return this.createContext }
    getItemSelector(){ return this.itemSelector }
}
